import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	name: {
		id: 'eoc.heartbeats.list.table-header.name.no-translate',
		defaultMessage: 'Name',
		description: 'Table header of name column',
	},
	lastPinged: {
		id: 'eoc.heartbeats.list.table-header.last-pinged.no-translate',
		defaultMessage: 'Last pinged',
		description: 'Table header of last pinged column',
	},
	nextPing: {
		id: 'eoc.heartbeats.list.table-header.next-ping.no-translate',
		defaultMessage: 'Next ping',
		description: 'Table header of next ping column',
	},
	teams: {
		id: 'eoc.heartbeats.list.table-header.owner-team.no-translate',
		defaultMessage: 'Teams',
		description: 'Table header of owner team column.',
	},
	status: {
		id: 'eoc.heartbeats.list.table-header.status.no-translate',
		defaultMessage: 'Status',
		description: 'Table header of status column',
	},
	actions: {
		id: 'eoc.heartbeats.list.table-header.actions.no-translate',
		defaultMessage: 'Actions',
		description: 'Table header of actions column',
	},
});

export default messages;
